import { Component, OnInit } from '@angular/core';
@Component({
  selector: 'app-commonauth',
  templateUrl: './commonauth.component.html',
  styleUrls: ['./commonauth.component.scss']
})
export class CommonAuthComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
